import '@jupyterlab/filebrowser/style/index.js';

import '@jupyter-notebook/tree/style/index.js';

import './base.css';
